<template>
  <el-row justify="center">
    <el-col :xs="24" :sm="22" :md="20" :lg="18">

      <div class="page-header">
        <h2 class="h4 mb-0">共享资源库</h2>
        <el-button type="primary" @click="$router.push('/resources/upload')">
          <i class="fas fa-upload me-2"></i>
          上传我的成果
        </el-button>
      </div>

      <el-card shadow="never">
        <el-table :data="resources" v-loading="isLoadingList" stripe style="width: 100%">

          <el-table-column prop="title" label="资源标题" min-width="250">
            <template #default="scope">
              <span class="fw-bold">{{ scope.row.title }}</span>
              <p class="mb-0 mt-1 table-description">
                {{ scope.row.description || '暂无描述' }}
              </p>
            </template>
          </el-table-column>

          <el-table-column prop="uploader_name" label="上传者" width="150" />

          <el-table-column label="上传日期" width="120">
            <template #default="scope">
              {{ new Date(scope.row.upload_date).toLocaleDateString() }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100" align="center">
            <template #default="scope">
              <el-link :href="scope.row.file" type="primary" download>
                <i class="fas fa-download me-1"></i>
                下载
              </el-link>
            </template>
          </el-table-column>

          <template #empty>
            <el-empty description="目前还没有人分享资源。" />
          </template>

        </el-table>

        <div class="text-center mt-4" v-if="nextResourcePageUrl">
          <el-button
            type="primary"
            plain
            @click="loadMoreResources"
            :loading="isMoreResourcesLoading">
            {{ isMoreResourcesLoading ? '正在加载...' : '加载更多资源' }}
          </el-button>
        </div>

      </el-card>

    </el-col>
  </el-row>
</template>

<script>
//
// <script> 部分完全保持不变
// (V3.0 的逻辑是完美的, V4.0 只是“换皮”)
//
import axios from 'axios';

export default {
  name: 'ResourceHubView',
  data() {
    return {
      isLoadingList: true,
      resources: [],
      isMoreResourcesLoading: false,
      nextResourcePageUrl: null,
    };
  },

  async mounted() {
    await this.fetchResources();
  },

  methods: {
    /**
     * 【GET】获取已批准的资源列表
     */
    async fetchResources() {
      this.isLoadingList = true;
      const token = localStorage.getItem('authToken');
      if (!token) { this.$router.push('/login'); return; }

      try {
        const response = await axios.get('/members/api/resources/', {
          headers: { 'Authorization': `Token ${token}` }
        });

        this.resources = response.data.results;
        this.nextResourcePageUrl = response.data.next;

      } catch (error) {
        console.error('获取资源列表失败:', error);
      } finally {
        this.isLoadingList = false;
      }
    },

    /**
     * 加载更多资源
     */
    async loadMoreResources() {
      if (!this.nextResourcePageUrl) return;

      this.isMoreResourcesLoading = true;
      const token = localStorage.getItem('authToken');

      try {
        const response = await axios.get(this.nextResourcePageUrl, {
          headers: { 'Authorization': `Token ${token}` }
        });

        this.resources.push(...response.data.results);
        this.nextResourcePageUrl = response.data.next;

      } catch (error) {
        console.error('加载更多资源失败:', error);
      } finally {
        this.isMoreResourcesLoading = false;
      }
    },
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.page-header .h4 {
  font-weight: 600;
}
.table-description {
  font-size: 0.85rem;
  color: var(--el-text-color-secondary);
  line-height: 1.5;
  margin-top: 4px !important;
}
.me-1 {
  margin-right: 0.25rem;
}
.me-2 {
  margin-right: 0.5rem;
}
.fw-bold {
  font-weight: 600;
}
.text-center {
  text-align: center;
}
.mt-4 {
  margin-top: 1.5rem;
}
.mb-0 {
  margin-bottom: 0;
}
</style>